import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-allowance-form',
  templateUrl: './fixed-allowance-form.component.html',
  styleUrls: ['./fixed-allowance-form.component.css']
})
export class FixedAllowanceFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-form/fixed-allowance-form.component.ts